
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/musik/suchen",
      function () {
        return require("private-next-pages/musik/suchen.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/musik/suchen"])
      });
    }
  